import BaseModule from "./base-module";

class Goods extends BaseModule {
  // 获取商品列表【+店铺】
  goodsSpuList(payload) {
    return this.post("/api/goods_spu/list", payload);
  }

  // 商品分类列表【+店铺】
  categoryList(payload) {
    return this.post("/api/category/list", payload);
  }

  // 获取商品详情
  goodsSpuDetail(payload) {
    return this.post("/api/goods_spu/get", payload);
  }

  // 系列商品列表
  goodsSeriesList(payload) {
    return this.post("/api/goods_spu/series", payload);
  }
}

export default new Goods();
